<!--
    transparentPendant 透明挂件
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="挂件 > 透明挂件" name="透明挂件">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="transparentPendant" label-width="80px">
              <el-form-item label="印刷">
                <el-select v-model="transparentPendant['印刷']" placeholder="印刷">
                  <el-option label="单面" value="单面"></el-option>
                  <el-option label="双面" value="双面"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工艺">
                <el-select v-model="transparentPendant['工艺']" placeholder="工艺">
                  <el-option label="烫金" value="烫金"></el-option>
                  <el-option label="烫银" value="烫银"></el-option>
                  <el-option label="镭射银" value="镭射银"></el-option>
                  <el-option label="珠光闪粉" value="珠光闪粉"></el-option>
                  <el-option label="磨砂闪粉" value="磨砂闪粉"></el-option>
                  <el-option label="镶钻" value="镶钻"></el-option>
                  <el-option label="透明部分" value="透明部分"></el-option>
                </el-select>
                <el-alert title="其它工艺请联系客服" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 20px 0 0 0;"></el-alert>
              </el-form-item>
              <el-form-item label="配件">
                <el-select v-model="transparentPendant['配件']" placeholder="请选择配件">
                  <el-option label="手机绳" value="手机绳"></el-option>
                  <el-option label="银色D字扣" value="银色D字扣"></el-option>
                  <el-option label="银色钥匙圈" value="银色钥匙圈"></el-option>
                  <el-option label="银色链珠" value="银色链珠"></el-option>
                  <el-option label="银色龙虾扣" value="银色龙虾扣"></el-option>
                  <el-option label="星星形配件" value="星星形配件"></el-option>
                  <el-option label="心形配件" value="心形配件"></el-option>
                  <el-option label="金色链珠" value="金色链珠"></el-option>
                  <el-option label="金色C字扣钥匙圈双用" value="金色C字扣钥匙圈双用"></el-option>
                  <el-option label="金色D字扣钥匙圈双用" value="金色D字扣钥匙圈双用"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="尺寸">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="transparentPendant['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="transparentPendant['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="transparentPendant['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number
                  v-model="transparentPendant['数量']"
                  :min="100"
                  :max="10000"
                  label="数量"
                ></el-input-number>
                <el-alert title="单款起定数为100" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin-top:20px;"></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button> <el-button v-on:click="clear()">清空</el-button> 
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "TransparentPendant",
  data() {
    return {
      forcollapse: ['allsame'],
      transparentPendant: {
        title: "透明挂件",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.transparentPendant);
       
    },
    clear() {
      this.$root.clearAlert()
      this.transparentPendant = {
        title: "透明挂件",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>